export class Module {
  tenantId: string;
  module: string;
  moduleId: string;
  moduleRole: string;
  isActive: boolean;
  moduleRoleAssignmentRequiresElevatedPrivileges: boolean;
}
